import { createSelector } from '@reduxjs/toolkit'
import { RuleType } from '@/models/http'
import { appSlice } from '@/store/appSlice'
import { RootState } from '@/store/configureStore'
import { sectorRulesSlice } from '..'

export const hasSectorRuleTypeSelector = createSelector(
  [
    sectorRulesSlice.selectors.rules,
    appSlice.selectors.sct,
    (_state: RootState, ruleType: RuleType) => ruleType,
  ],
  (rules, sct, ruleType): boolean => {
    if (sct === null || rules === null) {
      return false
    }

    return Boolean(
      rules.find(
        (rule) => sct.includes(rule.sectorOldId) && rule.ruleType === ruleType
      )
    )
  }
)
